export default {
    localhost: {
        url: 'http://localhost/mbs-api/public/',
        upload_path: 'http://localhost/mbs-api/upload/'
    },
    server: {
        //http://35.240.240.18/ old ip
        url: 'http://34.143.190.119/mbs-api/public/',
        upload_path: 'http://34.143.190.119/attachment/'
    },
    mega: {
        //http://35.240.240.18/ old ip
        url: 'http://34.143.190.119/mbs-api-mega/public/',
        upload_path: 'http://34.143.190.119/attachment/'
    }


}